import { BodyLong, BodyShort } from 'components/typography';
import React from 'react';
import { components } from 'react-select';
const ValueLabel = (props) => (React.createElement(components.MultiValueLabel, Object.assign({}, props), props.size === 'medium' ? (React.createElement(BodyLong, null, props.data.label)) : (React.createElement(BodyShort, null, props.data.label))));
ValueLabel.displayName = 'SelectMultiple.ValueLabel';
export default ValueLabel;
